import { useMutation, useQuery, useQueryClient } from 'react-query';
import { ErrorResponse } from '../../api';
import { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { AgreementPayload, UserApi } from '../../api';
import { User } from '../../model';
import { useToast } from '../../components/atoms/Toast';

export const useAgreements = () => {
  const { data } = useQuery('user', UserApi.fetch);
  const agreements = data?.agreements || [];
  const { toast } = useToast();
  const methods = useForm<User>({
    defaultValues: {
      ...data,
    },
  });

  const { handleSubmit } = methods;
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation<
    number[],
    ErrorResponse,
    AgreementPayload
  >(data => UserApi.editAgreements(data), {
    onSuccess() {
      queryClient.invalidateQueries('user');
    },
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const throttledSubmit = (async (values: AgreementPayload) => {
    setIsSubmitting(true);
    const transformedValues = {
      ...values,
      agreements: values.agreements.map((agreement) => ({
        ...agreement,
        has_agree: agreement.has_agree ? 1 : 0,
      })),
    };
    try {
      await mutateAsync(transformedValues);
          window.dispatchEvent(new CustomEvent('agreements-saved'));

      toast({
        variant: 'success',
        description: 'Zaktualizowano klauzule',
      });

    } catch (error) {
      toast({
        variant: 'error',
        description: 'Coś poszło nie tak!',
      });
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 1000);

    }
  });

  const onSubmit: SubmitHandler<AgreementPayload> = async (values) => {
    throttledSubmit(values);
  };
  // TODO: backend should return agreement label
  // TODO: translations should be added

  const requiredAgreements = agreements.filter(agreement => agreement.required);
  const optionalAgreements = agreements.filter(agreement => !agreement.required);

  return {
    methods,
    handleSubmit,
    onSubmit,
    requiredAgreements,
    optionalAgreements,
    isSubmitting,
  };
};
